export default "__VITE_ASSET__Ctq_sp$7__"